import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState
} from "react";

type CssVariableContextType = {
  setMessageBannerHeight: (height: number) => void;
};

const cssVariableContext = createContext<CssVariableContextType | null>(null);

export function CssVariableContextProvider({
  children
}: PropsWithChildren<unknown>): JSX.Element {
  const [messageBannerHeight, setMessageBannerHeight] = useState(0);

  useEffect(() => {
    console.log("messageBannerHeight", messageBannerHeight);
    document.documentElement.style.setProperty(
      "--padding-top",
      messageBannerHeight + "px"
    );
  }, [messageBannerHeight]);

  return (
    <cssVariableContext.Provider
      value={{
        setMessageBannerHeight
      }}
    >
      {children}
    </cssVariableContext.Provider>
  );
}

export const useCssVariableContext = (): CssVariableContextType => {
  const context = useContext(cssVariableContext);
  if (!context) {
    throw new Error(
      "useCssVariableContext must be used within a CssVariableContextProvider"
    );
  }
  return context;
};
